var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72727 9.64459V19.2446L16.3636 14.4446L8.72727 9.64459ZM21.8182 4.84459H13.5491L17.1382 0.896586L16.3636 0.0445862L12 4.84459H11.9673L7.60364 0.0445862L6.85091 0.896586L10.4291 4.84459H2.18182C0.981818 4.84459 0 5.92459 0 7.24459V21.6446C0 22.9646 0.981818 24.0446 2.18182 24.0446H21.8182C23.0182 24.0446 24 22.9646 24 21.6446V7.24459C24 5.92459 23.0182 4.84459 21.8182 4.84459ZM21.8182 21.6446H2.18182V7.24459H21.8182V21.6446Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelIcon);
export default __webpack_public_path__ + "static/media/Channel-icon.f26f7e5667963119b8f6ca73c76631bc.svg";
export { ForwardRef as ReactComponent };